export default "__VITE_ASSET__adc69420__"